
import React from 'react';
import styled from 'styled-components';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    title: string;
    onClick: () => void;
    style?: React.CSSProperties;
    textStyle?: React.CSSProperties;
    disabled?: boolean;
    rightIcon?: string;
    leftIcon?: string;
}

const AppButton: React.FC<ButtonProps> = ({
    title,
    onClick,
    style,
    textStyle,
    disabled,
    leftIcon,
    rightIcon,
    ...rest
}) => {
    const hasRightIcon = !!rightIcon;
    const [isClicking, setIsClicking] = React.useState(false);

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (!disabled && onClick && !isClicking) {
            setIsClicking(true);
            onClick();
            
            // Reset the clicking state after a short delay
            setTimeout(() => {
                setIsClicking(false);
            }, 300);
        }
    };

    return (
        <Button
            className={`app-button ${disabled ? 'app-button-disabled' : ''}`}
            style={style}
            onClick={handleClick}
            disabled={disabled}
            {...rest}
        >
            {leftIcon && <img src={leftIcon} alt="Left Icon" className="app-button-left-icon" />}
            <BtnText
                className={`app-button-text ${hasRightIcon ? 'app-button-text-with-icon' : ''}`}
                style={textStyle}
            >
                {title}
            </BtnText>
            {rightIcon && <img src={rightIcon} alt="Right Icon" className="app-button-right-icon" />}
        </Button>
    );
};

const Button = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #9282CB;
    border-radius: 8px;
    height: 44px;
    width: auto;
    border: 1px solid #9282cb;
    line-height: 44px;
    padding: 0 10px;
    cursor: pointer;
    pointer-events: auto;
    user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    box-sizing: border-box;

    img {
        height: 20px;
        width: 20px;
        pointer-events: none;
    }
    
    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
        pointer-events: auto;
    }
    
    &:active {
        transform: scale(0.98);
    }
`;

const BtnText = styled.span`
    color: #ffff;
    fontSize: 16px;
    fontWeight: '500';
    display: inline-block;
    vertical-align: middle;
`;



export default AppButton;
